module.exports = __webpack_public_path__ + "static/img/news2.c4b739d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news2.png
// module id = 9uZq
// module chunks = 1